import { z } from 'zod';

const id = z.string().min(1).max(128).regex(/^[A-Za-z0-9][A-Za-z0-9._:-]*$/u);
export const victimRiskPlanInputSchema = z.object({
  workCategoryId: id,
  responsibleIdentityId: id.nullable(),
  dueDate: z.string().date(),
}).strict();
export const victimRiskPlanSnapshotSchema = victimRiskPlanInputSchema.extend({
  workCategoryLabel: z.string().trim().min(1).max(160),
  responsibleName: z.string().trim().min(1).max(120).nullable(),
  responsibleContractorId: id.nullable(),
}).strict();
export type VictimRiskPlanInput = z.infer<typeof victimRiskPlanInputSchema>;
export const victimRiskPlanRecordSchema=z.object({
  schemaVersion:z.literal(1),entryId:id,tenantId:z.literal('kop'),siteId:id,contractorId:id,
  version:z.number().int().positive(),sourceVersion:z.number().int().positive(),
  sourceContextHash:z.string().regex(/^[a-f0-9]{64}$/u),plan:victimRiskPlanSnapshotSchema,
  createdBy:id,createdAt:z.string().datetime(),commandId:id,immutable:z.literal(true),
}).strict();
export type VictimRiskPlanView = z.infer<typeof victimRiskPlanSnapshotSchema> & {
  version: number;
  sourceCurrent: boolean;
};
